module.exports = (
  $scope,
  $state,
  $stateParams,
  auditTrail,
  project,
  managedUsers,
  User
) ->

  $scope.user = User

  # =========================
  # ---------Action ---------
  # =========================

  $scope.loadPage = (page) ->
    event_to_show = if $scope.filters.event
      if ($scope.filters.event.id == 13) then [9, 13] else $scope.filters.event.id
    else null

    params =
      project: $stateParams.project,
      page: page,
      start: (page - 1) * $scope.limit,
      user: $scope.filters.user,
      event: event_to_show
    $state.go('audit_trail', params)

  # =========================
  # ---------Select ---------
  # =========================

  $scope.eventFromStateParams = () ->
    return (e for e in $scope.event_types when e.id is parseInt($stateParams.event, 10))[0]

  # =========================
  # --------- Scope ---------
  # =========================

  $scope.hasContext = () ->
    parseInt($stateParams.event, 10) in [9, 13]

  $scope.showRichDiff = () ->
    parseInt($stateParams.event, 10) in [7, 9, 17]

  $scope.currentPage = $stateParams.page
  $scope.limit = 10
  $scope.project = project
  $scope.events = auditTrail.results or []
  $scope.totalEvents = auditTrail.count or 0
  $scope.managedUsers = managedUsers
  $scope.event_types = [
    {id: 3, description: 'Report exported'},
    {id: 4, description: 'Report state transitioned'},
    {id: 5, description: 'Report assignee changed'},
    {id: 7, description: 'Report summary edited'},
    {id: 8, description: 'Result dispositioned'},
    {id: 9, description: 'Workflow step summary edited'},
    {id: 10, description: 'Workflow step completed'},
    {id: 11, description: 'Search result opened'},
    {id: 16, description: 'Search result subresource opened'},
    {id: 12, description: 'Subject added'},
    {id: 13, description: 'Comment added'},
    {id: 14, description: 'Search refinement created'},
    {id: 17, description: 'Workflow summary edited'}
    {id: 20, description: 'Document deleted'}
  ]
  $scope.filters =
    user: $stateParams.user or null
    event: $scope.eventFromStateParams()
